// @flow

import * as React from "react";

import { type ImageType } from "../../types";

import Breadcrumbs from "../molecules/Breadcrumbs";
import Image from "../atoms/Image";

import { ReactComponent as Triangle } from "../../../assets/images/shape-triangle.svg";
import { ReactComponent as Circle } from "../../../assets/images/shape-circle.svg";
import { ReactComponent as Ring } from "../../../assets/images/shape-ring-thick-fill.svg";
import { PrimaryNavPad } from "./PrimaryNav";

type PropsType = {
    theme: "purple" | "orange" | "green" | "teal" | "pink" | "red" | "blue",
    heading: string,
    description?: string,
    image?: ImageType,
    size: "small" | "large",
};

const HeroInner = (props: {
    heading: string,
    description?: string,
}): React.Node => {
    return (
        <React.Fragment>
            <Breadcrumbs />
            <h1 className="hero-content__heading">{props.heading}</h1>
            <p className="hero-content__description">{props.description}</p>
        </React.Fragment>
    );
};

const HeroContent = (props: PropsType): React.Node => {
    const baseClassName = "hero-content";
    const classes = [baseClassName];

    if (props.theme) {
        classes.push(`${baseClassName}--${props.theme}`);
    }

    classes.push(`${baseClassName}--${props.size}`);

    return (
        <div className={classes.join(" ")}>
            <div className="hero-content__overlay">
                {props.size === "large" ? (
                    <Image
                        image={props.image}
                        size={"2048x2048"}
                        alt="test"
                        aspectRatio="13:5"
                    />
                ) : (
                    <React.Fragment>
                        <PrimaryNavPad />
                        <div className="container-fluid">
                            {/* Design elements */}
                            <Circle className="hero-content__circle-small" />
                            <Ring className="hero-content__ring" />
                            <Triangle className="hero-content__triangle" />
                            <div className="hero-content__diamond" />
                            <Circle className="hero-content__circle-small hero-content__circle-small--desktop-only" />

                            <div className="hero-content__row row">
                                <div
                                    className={`hero-content__col col-xs-12 col-md-offset-2 col-md-8 ${
                                        props.image ? "with-image" : "no-image"
                                    }`}
                                >
                                    <HeroInner
                                        heading={props.heading}
                                        description={props.description}
                                    />
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                )}
            </div>
            {props.size === "large" ? (
                <div className="hero-content__inner">
                    <div className="container-fluid">
                        {/* Design elements */}
                        <Circle className="hero-content__circle-small" />
                        <Ring className="hero-content__ring" />
                        <Triangle className="hero-content__triangle" />
                        <div className="hero-content__diamond" />

                        <div className="hero-content__row row">
                            <div className="hero-content__col col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                                <HeroInner
                                    heading={props.heading}
                                    description={props.description}
                                />
                            </div>
                        </div>

                        <div className="hero-content__row__gap" />
                    </div>
                </div>
            ) : props.image ? (
                <div className="hero-content__inner">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12 col-md-offset-1 col-md-10 col-lg-offset-2 col-lg-8">
                                <div className="hero-content__image">
                                    <Image
                                        image={props.image}
                                        size={"2048x2048"}
                                        alt="test"
                                        aspectRatio="3:2"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="hero-content__inner hero-content__inner--no-image">
                    <div className="hero-content__inner__gap" />
                </div>
            )}
        </div>
    );
};

HeroContent.defaultProps = {
    theme: "green",
};

export default HeroContent;
